import { proxy, useSnapshot } from 'valtio';
const closeConfirmationDialogStore = proxy({
    isOpen: false,
});
const setIsOpen = (isOpen) => {
    closeConfirmationDialogStore.isOpen = isOpen;
};
export const useCloseConfirmationDialogStore = () => {
    const { isOpen } = useSnapshot(closeConfirmationDialogStore);
    return { isOpen, setIsOpen };
};
